module.exports = exports = require('./ArrayUtils');
exports.getEquallySpacedData = require('./getEquallySpaced').getEquallySpacedData;
exports.SNV = require('./snv').SNV;
exports.binarySearch = require('ml-binary-search');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-array-utils/src/index.js
 ** module id = 22
 ** module chunks = 0
 **/